__turbopack_context__.v({
  "app_light_theme": "applied-filter-chip-module-scss-module__vUcYAa__app_light_theme",
  "body": "applied-filter-chip-module-scss-module__vUcYAa__body",
  "caret": "applied-filter-chip-module-scss-module__vUcYAa__caret",
  "chip": "applied-filter-chip-module-scss-module__vUcYAa__chip",
  "chip_disabled": "applied-filter-chip-module-scss-module__vUcYAa__chip_disabled",
  "chip_open": "applied-filter-chip-module-scss-module__vUcYAa__chip_open",
  "delete": "applied-filter-chip-module-scss-module__vUcYAa__delete",
  "dropdown": "applied-filter-chip-module-scss-module__vUcYAa__dropdown",
  "name": "applied-filter-chip-module-scss-module__vUcYAa__name",
  "overlay": "applied-filter-chip-module-scss-module__vUcYAa__overlay",
  "scrim": "applied-filter-chip-module-scss-module__vUcYAa__scrim",
});
